import { Component, OnInit, ViewChild }                             from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators }      from '@angular/forms';
import { ErrorStateMatcher }                                        from '@angular/material/core';
import { Router, ActivatedRoute }                                   from '@angular/router';
import { first }                                                    from 'rxjs/operators';
import { NgxSpinnerService }                                        from 'ngx-spinner';

import { AlertService, ProctorService }                             from '../_services';
import { Globals }                                                  from '../_helpers';
import { SearchFilterPipe }                                         from '../_pipes';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'app-examlist',
    templateUrl: './examlist.component.html'
})


export class ExamlistComponent implements OnInit {

    statusMsg: string = '';
    batch_name: string = '';
    exam_name: string = '';
    exam_date;
    localData = {};
    localBatch = {};
    localStudent = {};
    loading = false;
    submitted = false;
    returnUrl: string;
    examsData = [];
    query: string = '';

    isReporting:boolean = true;
    isProctering: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private proctorService: ProctorService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

  	ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.localBatch = JSON.parse(localStorage.getItem('localBatch'));

        if(this.localData['is_report'] != 1)
            this.isReporting = false;

        if(this.localData['is_proctoring'] != 1)
            this.isProctering = false;

        this.getExamDetailsByBatch();

        this.batch_name = this.localBatch['batch_name'];
        this.exam_name = this.localBatch['exam_name'];
        this.exam_date = this.localBatch['exam_date'];
  	}

  	private getExamDetailsByBatch(){
  		this.submitted = true;
          this.spinner.show();
        this.proctorService.getBatchExams(this.globals.root_url, this.localData['usercode'], this.localBatch['batchId'])
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.examsData = data.exams;
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status, '/dashboard');
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
      }
      

      
    public excelExport(exam_id:number){
        this.spinner.show();
        this.proctorService.getExamExcelReport(this.globals.root_url, this.localData['usercode'], exam_id)
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    if(data.path != '')
                        var downloadWindow = window.open(data.path, "Download", "width=100,height=100");
                        setTimeout(function(){
                            downloadWindow.close();
                        },10000);
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.loading = false;
                    this.globals.statusOpen(data.status);
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public reportView(exam_id:number){
        localStorage.setItem('localExam', JSON.stringify({exam_id:exam_id}));
        this.router.navigateByUrl('/students');
    }

    public studentAssessor(exam_id, type){
        localStorage.setItem('localExam', JSON.stringify({exam_id:exam_id}));
        this.router.navigateByUrl('/proctor-view/'+type);
    }

}


